module.exports = __webpack_public_path__ + "img/AsiaBlue.612806b5.png";